/**
 * Authorization Roles
 */
const authRoles = {
  admin: ['admin'],
  manager: ['admin', 'manager'],
  leadEditor: ['admin', 'leadEditor'],
  leads: ['admin', 'manager', 'leadEditor'],
  editor: ['admin', 'leadEditor', 'editor'],
  leadReviewer: ['admin', 'manager', 'leadEditor', 'editor', 'leadReviewer'],
  reviewer: [
    'admin',
    'manager',
    'leadEditor',
    'editor',
    'leadReviewer',
    'reviewer'
  ],
  user: [
    'admin',
    'manager',
    'leadEditor',
    'editor',
    'leadReviewer',
    'reviewer',
    'user'
  ],
  onlyGuest: []
};

export default authRoles;
